import React from 'react'
import { Card, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import getSocialMediaIconByType from 'libs/socialMediaInteractionsHelpers/getSocialMediaIconByType'
import Assets from 'app/configs/assetConfigs'
import {
  SOCIAL_MEDIA_ICON_SIZE,
  SOCIAL_MEDIA_INTERACTIONS_FORMATTED_BASE,
} from './configs/socialMediaInteractions'
import putSquareSize from 'libs/socialMediaInteractionsHelpers/putSquareSize'
const { likesIcon, commentsIcon } = Assets.socialMediaInteractionIcons

const nailPageNameByType = (pageType, pageName) =>
  pageType === 'linkedin' || pageType === 'twitter'
    ? `${pageType.toUpperCase()}`
    : pageType === 'instagram'
      ? `@${pageName}`
      : pageName

const SocialMediaPageMetricCard = ({
  pageName = '',
  pageType = '',
  likesCount = 0,
  commentsCount = 0,
  pageId = '',
}) => {
  return (
    <Card className="flex flex-col">
      <div className="px-5 pb-5">
        <div className="mt-4">
          {pageName && (
            <Typography component="h2" className="text-16 py-4">
              {nailPageNameByType(pageType, pageName)}
            </Typography>
          )}
          <div className="flex py-4">
            <img
              className="mr-8"
              {...putSquareSize(SOCIAL_MEDIA_ICON_SIZE)}
              src={`${getSocialMediaIconByType(pageType)}`}
              alt={`${pageType.toUpperCase()}'s logo`}
            />
            <div className="page-metrics-details">
              <div className="flex">
                <img src={likesIcon} alt="Social media account likes icon" />
                <Typography>
                  <span className="px-4">{likesCount}</span>
                  <FormattedMessage
                    id={`${SOCIAL_MEDIA_INTERACTIONS_FORMATTED_BASE}.likes`}
                  />
                </Typography>
              </div>
              <div className="flex">
                <img
                  src={commentsIcon}
                  alt="Social media account comments icon"
                />
                <Typography>
                  <span className="px-4">{commentsCount}</span>
                  <FormattedMessage
                    id={`${SOCIAL_MEDIA_INTERACTIONS_FORMATTED_BASE}.comments`}
                  />
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default SocialMediaPageMetricCard
